import { React } from 'react';

const Splash = () => {

	return (
		<div className="splash">
			<div className='brand-text'>Ithaca College Library</div>
			<div className='image-holder'><svg x="0px" y="0px" viewBox="0 0 32 29" enableBackground="new 0 0 32 29"><defs><clipPath id="clip-shape"><rect x="235" y="40" width="18" height="54"/><rect x="203" y="40" width="18" height="54"/><rect x="235" y="120" width="18" height="54"/><rect x="171" y="40" width="18" height="54"/><rect x="139" y="40" width="18" height="54"/><rect x="139" y="120" width="18" height="54"/><rect x="139" y="196" width="18" height="54"/><rect x="107" y="40" width="18" height="54"/><rect x="75" y="40" width="18" height="54"/><rect x="43" y="40" width="18" height="54"/><rect x="75" y="120" width="18" height="54"/><rect x="267" y="40" width="18" height="54"/><rect x="171" y="120" width="18" height="54"/><rect x="171" y="196" width="18" height="54"/></clipPath></defs></svg></div>
		</div>
	)
};

export default Splash;